import { saveAs } from 'file-saver/FileSaver';

export function downloadWithFallback(blob, fileName) {
  if (!blob)
    return;
  if (!navigator.userAgent.match('CriOS')) {
    saveAs(blob, fileName);
  } else {
    // For Chrome in iOS devices.
    var reader = new FileReader();
    reader.onloadend = () => {
      const a = document.createElement('a');
      a.href = reader.result;
      a.style.display = 'none';
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.parentNode.removeChild(a);
    };
    reader.readAsDataURL(blob);
  }
}
